"use client";
import { useEffect, useState } from "react";

const ScrollToTop = () => {
  const [showScrollToTop, setShowScrollToTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.pageYOffset;
      const documentHeight = document.documentElement.scrollHeight;
      const scrollThreshold = documentHeight * 0.2;

      setShowScrollToTop(scrollPosition > scrollThreshold);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className={`scroll-to-top ${showScrollToTop ? "show" : ""}`}>
      <button onClick={scrollToTop}>↑</button>
    </div>
  );
};

export default ScrollToTop;
